import PropTypes from 'prop-types';
import { Box, Tooltip, Typography } from '@mui/material';
import { piiProps, piiTitle } from 'src/components/DemoBlur';
import {
    tableCellInnerBoxStyle,
} from '../../../../styles/NewLeadTableRowStyle';

const EmailField = ({ rowData }) => (
    <Tooltip title={piiTitle(`${rowData?.email}`)}>
        <Box sx={{ ...tableCellInnerBoxStyle, justifyContent: 'flex-start' }}>
            <Typography variant='body2' noWrap {...piiProps}>{rowData?.email || ''}</Typography>
        </Box>
    </Tooltip>
);

EmailField.propTypes = {
    rowData: PropTypes.any,
};

export default EmailField;
